<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <form [formGroup]="entityForm">

    <mat-tab-group animationDuration="0ms">
      <mat-tab [label]="'Generali' | translate">
        <div class="restoration-general">
          <mat-form-field>
            <input
              matInput
              formControlName="esecutore"
              [placeholder]="'Esecutore'">
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="descrizione"
              [placeholder]="'Descrizione'">
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="dataInizio"
              mask="00/00/0000"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="false"
              [placeholder]="'Data Inizio (dd/mm/aaaa)' | translate">
            <mat-error>Formato data non valido</mat-error>
          </mat-form-field>
          <mat-form-field>
            <input
              matInput
              formControlName="dataFine"
              mask="00/00/0000"
              [showMaskTyped]="true"
              [dropSpecialCharacters]="false"
              [placeholder]="'Data Fine (dd/mm/aaaa)' | translate">
            <mat-error>Formato data non valido</mat-error>
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab [label]="'Allegati' | translate">
        <app-attachments-manager [form]="entityControls?.allegati"></app-attachments-manager>
      </mat-tab>
    </mat-tab-group>

    <div class="restoration-actions">
      <button
        mat-button
        mat-raised-button
        type="submit"
        (click)="completeHandler()">
        {{ mainActionLabel }}
      </button>
    </div>
  </form>
</mat-dialog-content>
